/* unplugin-vue-components disabled */import { render } from "./section-title.vue?vue&type=template&id=65913da6&scoped=true"
import script from "./section-title.vue?vue&type=script&lang=js"
export * from "./section-title.vue?vue&type=script&lang=js"

import "./section-title.vue?vue&type=style&index=0&id=65913da6&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65913da6"],['__file',"src/pages/pulse/section-title.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65913da6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65913da6', __exports__)) {
    api.reload('65913da6', __exports__)
  }
  
  module.hot.accept("./section-title.vue?vue&type=template&id=65913da6&scoped=true", () => {
    api.rerender('65913da6', render)
  })

}


export default __exports__